module.exports = __webpack_public_path__ + "img/hudianbiao.fd3191df.png";